import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoEsquemasEsquemaComponent {
  data
  onChange
  catalogos = {
    metodosCalculoComision: [],
    metodosCalculoSuministro: [],
    tiposComision: [],
  }

  constructor ($q, CatalogoMetodosCalculoSuministro, CatalogoMetodosCalculoComision, CatalogoTiposComision) {
    this.$q = $q
    this.CatalogoMetodosCalculoSuministro = CatalogoMetodosCalculoSuministro
    this.CatalogoMetodosCalculoComision = CatalogoMetodosCalculoComision
    this.CatalogoTiposComision = CatalogoTiposComision
  }

  $onInit () {
    this.promise = this.$q.all([
      this.CatalogoMetodosCalculoComision.get()
        .then(({data}) => (this.catalogos.metodosCalculoComision = data)),
      this.CatalogoMetodosCalculoSuministro.get()
        .then(({data}) => (this.catalogos.metodosCalculoSuministro = data)),
      this.CatalogoTiposComision.get()
        .then(({data}) => (this.catalogos.tiposComision = data)),
    ])
  }

  notificar () {
    console.log('notificar')
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('fanProyectoEsquemasEsquema', {
  controller: FanProyectoEsquemasEsquemaComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/component.js